module.exports = __webpack_public_path__ + "static/media/favicon.f1ebc748.ico";